import useSWR from "swr";
import {AXIOS} from "../../../services/api";

export function useSubscriptionPlans() {
	const {
		data: monthlyDataResponse,
		error: monthlyError,
		isLoading: isMonthlyLoading,
		mutate: revalidateMonthly,
	} = useSWR('/subscription-plans?recurring=month', AXIOS.get);

	const {
		data: yearlyDataResponse,
		error: yearlyError,
		isLoading: isYearlyLoading,
		mutate: revalidateYearly,
	} = useSWR('/subscription-plans?recurring=year', AXIOS.get);

	const revalidate = () => {
		revalidateMonthly();
		revalidateYearly();
	};

	return {
		monthlyData: monthlyDataResponse?.data ?? [],
		yearlyData: yearlyDataResponse?.data ?? [],
		error: monthlyError || yearlyError,
		loading: isMonthlyLoading || isYearlyLoading,
		revalidate,
	};
}
